import { Accordion } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { sendAccordionClick } from "../../../common/tracking";
import type { ContentfulAccordion } from "../../../common/types/cmsTypes";
import RichTextRenderer from "../RichTextRenderer";

type AccordionProps = {
   accordionContent: ContentfulAccordion;
};

const CmsAccordion = ({ accordionContent }: AccordionProps) => {
   const title = accordionContent.fields.title;
   const content = accordionContent.fields.content;

   return (
      <Accordion
         onOpenChange={(isOpen) => isOpen && sendAccordionClick(title)}
         label={title}
         borderVariant="none"
         className="mb-2"
      >
         <RichTextRenderer document={content} context="simple-article" variant="simple" />
      </Accordion>
   );
};

export default observer(CmsAccordion);
